// -*- coding: utf-8 -*-
// Generated by scripts/generate_from_specs.py
// Needs

export default {
    FOR_BEGINNERS: "sccgQZDd.sAQsauuo",
    INTERNET: "Hsw9k7Bz.G4h2UBuK",
    MATERIALS: "Hsw9k7Bz",
    OTHER_SUPPLIES: "Hsw9k7Bz.#lLv#LB7",
    PAPER_PENCIL: "Hsw9k7Bz.OFIbUAK9",
    PEERS: "lsoCk5Uy.MKIzZKDO",
    PEOPLE: "lsoCk5Uy",
    PRIOR_KNOWLEDGE: "sccgQZDd",
    SPECIAL_SOFTWARE: "Hsw9k7Bz.dbXQw755",
    TEACHER: "lsoCk5Uy.H&MVs7S#",
};
